import { ComponentType, FunctionComponent, ReactElement } from 'react'

import withStyles, { ClassNameMap } from '@material-ui/core/styles/withStyles'
import MuiTooltip from '@material-ui/core/Tooltip'
import Zoom from '@material-ui/core/Zoom'
import { TransitionProps } from '@material-ui/core/transitions';

const MuiTealToolTip = withStyles(() => ({
  arrow: {
    color: '#004b7a',
    fontSize: '0.5rem',
    '&::before': {
      color: '#004b7a'
    }
  },
  tooltip: {
    backgroundColor: '#004b7a',
    color: 'white',
    fontSize: '0.875rem'
  }
}))(MuiTooltip)

const TealToolTip: FunctionComponent<TealToolTipProps> =
  ({
    children, title, enterDelay = 800, arrow = true,
    placement = 'bottom', TransitionComponent = Zoom, ...props
  }) => (
    <MuiTealToolTip {...{ title, enterDelay, arrow, placement, TransitionComponent }} {...props}>
      {children}
    </MuiTealToolTip>
  )

interface TealToolTipProps {
  children: ReactElement;
  title: string;
  leaveDelay?: number;
  enterDelay?: number;
  arrow?: boolean;
  placement?: "bottom" | "left" | "right" | "top" | "bottom-end" | "bottom-start" | "left-end" | "left-start" | "right-end" | "right-start" | "top-end" | "top-start";
  open?: boolean;
  TransitionComponent?: ComponentType<TransitionProps>;
  classes?: Partial<ClassNameMap<string>>
}

export default TealToolTip
